// @flow
import type ThreeApp from './threeApp'
import type { THREE } from 'three'
import type { DailyItemsType, DailyItemType } from 'database-helper'

export default class DailyItemsApp {
  dailyItems: DailyItemsType
  keys: Array<string>
  dailyItem: DailyItemType
  overviewItem: DailyItemType

  constructor(dailyItems: DailyItemsType) {
    this.dailyItems = dailyItems
    this.keys = Object.keys(dailyItems)
    this.overviewItem = dailyItems[this.keys[this.keys.length - 1]]
    this.setDailyItemThroughKey(this.keys[this.keys.length - 1])
  }

  /* GETTERS */
  getDailyItemThroughCameraPos (cameraPos: number, ThreeApp: ThreeApp, scene: THREE.Scene): DailyItemType {
    const supposedIndex = Math.floor(ThreeApp.getDailyItemIndex(cameraPos, this.getOverviewItemIndex(), this.getOverviewItem(), scene))
    // console.log(supposedIndex)
    return this.getDailyItemThroughIndex(supposedIndex)
  }
  
  getDailyItemThroughIndex (index: number): DailyItemType {
    if (index >= this.keys.length) return this.dailyItems[this.keys[this.keys.length - 1]]
    if (index <= 0) return this.dailyItems[this.keys[0]]
    const key = this.keys[index]
    return this.dailyItems[key] || this.getDailyItemThroughIndex(index - 1)
  }

  getDailyItems (): DailyItemsType { return this.dailyItems }

  getDailyItem (): DailyItemType { return this.dailyItem }

  getDailyItemThroughUID (uid: ?string): ?DailyItemType {
    if (!uid) return null
    return this.dailyItems[uid] || null
  }

  getDailyItemsAsAnArray (): Array<DailyItemType> {
    // Object.values is more correct here.
    // But flow has trouble with it
    return this.keys.map((key: string): DailyItemType => this.dailyItems[key])
  }

  getItemIndex (uid: string): number {
    return this.keys.indexOf(uid)
  }

  getDailyItemIndex (): number {
    return this.getItemIndex(this.dailyItem.uid)
  }

  getOverviewItem (): DailyItemType { return this.overviewItem }

  getOverviewItemIndex (): number {
    const overviewItem = this.getOverviewItem()
    return this.getItemIndex(overviewItem.uid)
  }

  /* SETTERS */
  setDailyItem (dailyItem: DailyItemType, ThreeApp: ThreeApp, scene: THREE.Scene) {
    this.dailyItem = dailyItem
    const index = this.keys.indexOf(dailyItem.uid)
    if (index === this.keys.length - 2) ThreeApp.unblur(dailyItem.uid, scene)
  }

  setDailyItemThroughKey (key: string) { this.dailyItem = this.dailyItems[key] }

  setOverviewItem (overviewItem: DailyItemType) { this.overviewItem = overviewItem }

  /* HELPERS */
  cameraUpdated (cameraZPos: number, ThreeApp: ThreeApp, scene: THREE.Scene) {
    const newItem = this.getDailyItemThroughCameraPos(cameraZPos, ThreeApp, scene)
    if (newItem.uid !== this.dailyItem.uid) {
      this.setDailyItem(newItem, ThreeApp, scene)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/dailyItemsApp.js